import { useEffect, useState } from "react";
import { useContract } from "./useContract";
import { useTemplate } from "~/entity/Template";
import { AdditionalIProps, ContractItemIProps } from "../model/schema";
import {
  formatDateObject,
  formatDateObjectForT,
} from "~/pages/ListOfDocuments/Modals/helper";

interface SelectedAdditionalIProps
  extends Pick<
    AdditionalIProps,
    | "dealerSignedDate"
    | "startDateForIS"
    | "startForPrint"
    | "closeDateForIS"
    | "closeForPrint"
    | "ursosSignedDate"
  > {}
interface SelectedContractIProps
  extends Pick<
    ContractItemIProps,
    | "vaz_requisitesId"
    | "isHeadCompany"
    | "id"
    | "contractDate"
    | "closeForPrint"
    | "contractNumber"
  > {}

export const useGetAdditionalById = ({ id, parentContractId, printFormId }) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getAdditionalById, getContractById } = useContract();
  const { getTemplateById } = useTemplate();

  const fetchData = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const [parent, additionalById, templateItem] = await Promise.all([
        getContractById(parentContractId),
        getAdditionalById(id),
        getTemplateById(printFormId),
      ]);

      if (parent) {
        const {
          vaz_requisitesId,
          isHeadCompany,
          id,
          contractDate,
          contractNumber,
        }: SelectedContractIProps = parent.data;
        setData((data) => {
          return {
            ...data,
            vaz_requisitesId,
            isHeadCompany: isHeadCompany ? "Да" : "Нет",
            id,
            contractDateParent: formatDateObjectForT(contractDate),
            contractNumberParent: contractNumber,
          };
        });
      }
      if (additionalById) {
        const {
          dealerSignedDate,
          startDateForIS,
          startForPrint,
          closeDateForIS,
          closeForPrint,
          ursosSignedDate,
        }: Partial<SelectedAdditionalIProps> = additionalById.data;
        setData((data) => {
          return {
            ...data,
            dealerSignedDate: formatDateObjectForT(dealerSignedDate),
            startDateForIS: formatDateObjectForT(startDateForIS),
            startForPrint: formatDateObjectForT(startForPrint),
            closeDateForIS: formatDateObjectForT(closeDateForIS),
            closeForPrint: formatDateObjectForT(closeForPrint),
            ursosSignedDate: formatDateObjectForT(ursosSignedDate),
          };
        });
      }
      if (templateItem) {
        setData((data) => {
          return {
            ...data,
            printFormId: {
              value: templateItem.data.id.toString(),
              label: templateItem.data.name,
            },
          };
        });
      }
    } catch (error) {
      setError("Не удалось загрузить доп. соглашение");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { data, isLoading, error };
};
